import React, {useRef} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl, useIntl} from "react-intl";

import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';

import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {setLookIntroStep, setLookOverlayOpened} from "../../../actions/lookFunctions";
import {LOOK_INTRO_STEPS, LOOK_OVERLAYS} from "../../look/core/constants";
import {getCommonVisualizerType, IS_QKB_UI} from "../../../config";
import {setLookAiImageOpened} from "../aiActions";
import LookIntroPopper from "../../look/lookNavigation/lookIntro/lookIntroPopper";
import {imageIsRenderedAndUserIsNotLoggedIn} from "../aiFunctions";
import {useAnimationFinishedTeaser} from "./useAnimationFinishedTeaser";
import LookSideBarAIPanelFinishedRenderContent from "./LookSideBarAIPanelFinishedRenderContent";
import LookSideBarAIPanelFinishedRenderPopper from "./LookSideBarAIPanelFinishedRenderPopper";

const LookSideBarAIPanel = (props) => {

  const {setLookOverlayOpened, disabled, introStep, setLookIntroStep, sidebarButtonClicked, lookOverlayOpened, isMobile,
    lookAiRenderFinished, aiResults, setLookAiImageOpened, fabricatorData, isPhoneNumberValidated, aiLoading} = props;
  const anchorRef = useRef(null);

  const {animationActive, animationShown} = useAnimationFinishedTeaser({fabricatorData, aiLoading, lookOverlayOpened})

  const intl = useIntl();

  if (!fabricatorData.aiSettings.enableAI) {
    return null;
  }

  const realDisabled = disabled || ((introStep !== LOOK_INTRO_STEPS.welcome) && (introStep !== LOOK_INTRO_STEPS.aiStep));
  const visualizerType = getCommonVisualizerType();
  const showLeadOverlay = !isPhoneNumberValidated;

  const aiPanelClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidePanelAIClicked);
    if (introStep === LOOK_INTRO_STEPS.aiStep) {
      setLookIntroStep();
      return false;
    }
    setLookOverlayOpened(LOOK_OVERLAYS.aiPanel);
    if (lookAiRenderFinished || imageIsRenderedAndUserIsNotLoggedIn(showLeadOverlay, aiResults)) {
      setLookAiImageOpened(true);
    }
    if (sidebarButtonClicked) {
      sidebarButtonClicked();
    }
  }

  return (
    <div ref={anchorRef}
         className={"cursor-pointer look-ai__sidebar transition2 relative"
      + (lookOverlayOpened === LOOK_OVERLAYS.aiPanel ? " look-ai__sidebar--hidden" : "")
      + (IS_QKB_UI ? " fixed u-top-1/2 look-ai__sidebar--qkb" : "")
      + (animationActive && !animationShown && !lookAiRenderFinished ? " look-ai__sidebar--teaser" : "")
      + (lookAiRenderFinished ? " look-ai__sidebar--finished-rendering" : "")}
         onClick={realDisabled ? null : aiPanelClick}>
      {lookAiRenderFinished ? (
        <LookSideBarAIPanelFinishedRenderContent/>
      ) : (
        <div className="look-ai__sidebar-content u-pr-1 u-pl-1 u-h-full flex flex--column flex--center">
          <div className="look-ai__title u-leading-1 bold flex flex--center u-gap-025">
            <CreateNewFolderOutlinedIcon/>
            <span><FormattedMessage id="look.ai.sidebar.title"/></span>
          </div>
          <span className="look-ai__text u-leading-075 max-w-[172px] text-center">
            <FormattedMessage id={isMobile ? "look.ai.sidebar.mobile.text" : "look.ai.sidebar.text"}/>
          </span>
          <div className="u-w-175 absolute flex nowrap flex--center look-ai__sidebar-text text-capitalize bold">
            <FormattedMessage id="look.ai.sidebar.rotateText" values={{
              visualizerType: (intl.formatMessage({id: "rooms." + visualizerType})).toLowerCase(),
            }}/>
          </div>
        </div>
      )}
      <LookIntroPopper anchorRef={anchorRef}
                       currentStep={LOOK_INTRO_STEPS.aiStep}
                       toolTipText={"look.intro.aiStep.tooltip"}
                       visualizerType={visualizerType}/>
      <LookSideBarAIPanelFinishedRenderPopper anchorRef={anchorRef}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {activeTheme, isMobile} = store.serverState;
  const {lookLayoutOpened, introStep, lookOverlayOpened} = store.lookState;
  const {lookAiRenderFinished, aiResults, aiLoading} = store.aiState;
  const fabricatorData = store.fabricatorState;
  const {isPhoneNumberValidated} = store.userState;

  return {
    activeTheme,
    isMobile,
    lookLayoutOpened,
    introStep,
    fabricatorData,
    lookOverlayOpened,
    lookAiRenderFinished,
    aiResults,
    isPhoneNumberValidated,
    aiLoading,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookIntroStep,
  setLookAiImageOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookSideBarAIPanel)
)
